<template>
  <router-view />
</template>

<script>
export default {
  mounted() {
    const {
      VUE_APP_TITLE,
      VUE_APP_DESCRIPTION,
      VUE_APP_KEYWORDS,
      VUE_APP_CANONICAL,

      VUE_APP_OG_TITLE,
      VUE_APP_OG_DESCRIPTION
    } = process.env

    if (VUE_APP_TITLE) document.title = VUE_APP_TITLE

    if (VUE_APP_DESCRIPTION)
      document
        .querySelector('meta[name="description"]')
        .setAttribute('content', VUE_APP_DESCRIPTION)

    if (VUE_APP_KEYWORDS)
      document
        .querySelector('meta[name="keywords"]')
        .setAttribute('content', VUE_APP_KEYWORDS)

    if (VUE_APP_OG_TITLE)
      document
        .querySelector('meta[property="og:title"]')
        .setAttribute('content', VUE_APP_OG_TITLE)

    if (VUE_APP_OG_DESCRIPTION)
      document
        .querySelector('meta[property="og:description"]')
        .setAttribute('content', VUE_APP_OG_DESCRIPTION)

    if (VUE_APP_CANONICAL) {
      const link = document.createElement('link')
      link.setAttribute('rel', 'canonical')
      link.setAttribute('href', VUE_APP_CANONICAL)
      document.head.appendChild(link)
    }
  }
}
</script>

<style lang="scss">
// Import Bulma and Buefy styles
@import '~bulma';
@import '~buefy/src/scss/buefy';

@import '@/scss/_spacing.scss';
@import '@/scss/_custom.scss';
@import '@/scss/_widget.scss';
</style>
